
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-petrol-700 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <h4 className="text-lg font-bold mb-4">Tratamientos</h4>
            <div className="h-1 w-12 bg-olive-500 mb-6"></div>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('tipos')} className="text-sky-200 hover:text-white transition-colors cursor-pointer">
                  Brackets Metálicos
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('tipos')} className="text-sky-200 hover:text-white transition-colors cursor-pointer">
                  Brackets Estéticos
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('tipos')} className="text-sky-200 hover:text-white transition-colors cursor-pointer">
                  Ortodoncia Invisible
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('tipos')} className="text-sky-200 hover:text-white transition-colors cursor-pointer">
                  Ortodoncia Lingual
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('tipos')} className="text-sky-200 hover:text-white transition-colors cursor-pointer">
                  Ortodoncia Infantil
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Recursos</h4>
            <div className="h-1 w-12 bg-olive-500 mb-6"></div>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('casos')} className="text-sky-200 hover:text-white transition-colors cursor-pointer">
                  Casos Clínicos
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('doctores')} className="text-sky-200 hover:text-white transition-colors cursor-pointer">
                  Nuestros Especialistas
                </button>
              </li>
              <li>
                <a href="#" className="text-sky-200 hover:text-white transition-colors">
                  Blog de Ortodoncia
                </a>
              </li>
              <li>
                <a href="#" className="text-sky-200 hover:text-white transition-colors">
                  Guías y Consejos
                </a>
              </li>
              <li>
                <a href="#" className="text-sky-200 hover:text-white transition-colors">
                  Preguntas Frecuentes
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Clínicas</h4>
            <div className="h-1 w-12 bg-olive-500 mb-6"></div>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-sky-200 hover:text-white transition-colors">
                  Madrid
                </a>
              </li>
              <li>
                <a href="#" className="text-sky-200 hover:text-white transition-colors">
                  Barcelona
                </a>
              </li>
              <li>
                <a href="#" className="text-sky-200 hover:text-white transition-colors">
                  Valencia
                </a>
              </li>
              <li>
                <a href="#" className="text-sky-200 hover:text-white transition-colors">
                  Sevilla
                </a>
              </li>
              <li>
                <button onClick={() => scrollToSection('clinicas')} className="text-sky-200 hover:text-white transition-colors cursor-pointer">
                  Ver Todas
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Contacto</h4>
            <div className="h-1 w-12 bg-olive-500 mb-6"></div>
            <ul className="space-y-3">
              <li className="text-sky-200">
                <i className="ri-phone-line mr-2"></i>
                +34 900 123 456
              </li>
              <li className="text-sky-200">
                <i className="ri-mail-line mr-2"></i>
                info@ortodonciaespecializada.com
              </li>
              <li className="text-sky-200">
                <i className="ri-time-line mr-2"></i>
                Lun - Vie: 9:00 - 20:00
              </li>
              <li className="text-sky-200">
                <i className="ri-time-line mr-2"></i>
                Sáb: 10:00 - 14:00
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-petrol-500 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="mb-4 md:mb-0">
              <img 
                src="https://public.readdy.ai/ai/img_res/e515f14a-a9fd-442b-99b0-c74c61c69843.png" 
                alt="Ortodoncia Especializada" 
                className="h-10 mb-2"
              />
              <p className="text-sky-200 text-sm">Transformando sonrisas desde 1998</p>
              <div className="h-1 w-24 bg-olive-500 mt-2"></div>
            </div>

            <div className="text-center md:text-right">
              <div className="flex items-center justify-center md:justify-end space-x-4 mb-4">
                <a href="#" className="w-10 h-10 bg-olive-500 rounded-full flex items-center justify-center hover:bg-olive-600 transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-olive-500 rounded-full flex items-center justify-center hover:bg-olive-600 transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-olive-500 rounded-full flex items-center justify-center hover:bg-olive-600 transition-colors cursor-pointer">
                  <i className="ri-youtube-fill text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-olive-500 rounded-full flex items-center justify-center hover:bg-olive-600 transition-colors cursor-pointer">
                  <i className="ri-linkedin-fill text-lg"></i>
                </a>
              </div>
              <p className="text-sky-200 text-sm mb-2">
                © 2024 Ortodoncia Especializada. Todos los derechos reservados.
              </p>
              <div className="flex items-center justify-center md:justify-end space-x-4 text-sm">
                <a href="#" className="text-sky-200 hover:text-white transition-colors">
                  Política de Privacidad
                </a>
                <span className="text-petrol-500">|</span>
                <a href="#" className="text-sky-200 hover:text-white transition-colors">
                  Términos y Condiciones
                </a>
                <span className="text-petrol-500">|</span>
                <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sky-200 hover:text-white transition-colors">
                  Website Builder
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
